"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.setClipboardText = setClipboardText;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function setClipboardText(text) {
  // create a tiny invisible text area to programatically copy text
  var id = 'mycustom-clipboard-textarea-hidden-id';
  var existsTextarea = document.getElementById(id);
  if (!existsTextarea) {
    // if text area does not exist
    var textarea = document.createElement('textarea');
    textarea.id = id;
    textarea.style.position = 'fixed';
    textarea.style.top = 0;
    textarea.style.left = 0;
    textarea.style.width = '1px';
    textarea.style.height = '1px';
    textarea.style.padding = 0;
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.background = 'transparent';
    document.querySelector('body').appendChild(textarea);
    existsTextarea = document.getElementById(id);
  }
  existsTextarea.value = text;
  existsTextarea.select();
  document.execCommand('copy');
  (0, _cccisdNotification["default"])('Link copied!');
}
var Boilerplate = window.cccisd.boilerplate;
var UrlInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(UrlInfo, _React$Component);
  var _super = _createSuper(UrlInfo);
  function UrlInfo() {
    var _this;
    _classCallCheck(this, UrlInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getUrlText", function () {
      var _this$props$cycle = _this.props.cycle,
        hash = _this$props$cycle.hash,
        endpoint = _this$props$cycle.endpoint,
        _this$props$cycle$set = _this$props$cycle.settings,
        settings = _this$props$cycle$set === void 0 ? {} : _this$props$cycle$set;
      var useEndpoint = settings.useEndpoint;
      return Boilerplate.url(endpoint && useEndpoint ? "/survey/".concat(endpoint) : "/d/".concat(hash));
    });
    return _this;
  }
  _createClass(UrlInfo, [{
    key: "render",
    value: function render() {
      var url = this.getUrlText();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].shaderbox
      }, /*#__PURE__*/_react["default"].createElement("h4", {
        className: _style["default"].label
      }, "Take this Quest at:", ' ', /*#__PURE__*/_react["default"].createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, url)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])('btn', 'btn-info', _style["default"].copy),
        onClick: function onClick() {
          return setClipboardText(url);
        }
      }, "Copy ", /*#__PURE__*/_react["default"].createElement(_copy["default"], null)));
    }
  }]);
  return UrlInfo;
}(_react["default"].Component);
exports["default"] = UrlInfo;
_defineProperty(UrlInfo, "propTypes", {
  cycle: _propTypes["default"].object
});